<template src="@/templates/reservations/voucher-list.html"></template>

<script>
import userApi from '@/api/userApi';
import { restEndpoint } from '@/config.json';
import userAuthStore from '@/store/userAuthStore';
import entityStore from '@/store/entityStore';

export default {
  props: [
    'reservationId',
    'travelPackageType',
  ],
  data() {
    return {
      vouchers: [],
      isLoading: true,
      token: userAuthStore.state.token,
      entity: entityStore.state,
    };
  },
  computed: {
    show() {
      return (this.viewableVouchers.length > 0) && this.entity.name !== 'aircruise';
    },
    viewableVouchers() {
      return this.vouchers.filter(voucher => this.showVoucher(voucher));
    },
    downloadUrl() {
      return `${restEndpoint}/reservation/${this.reservationId}/download-voucher`;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      userApi.getVouchers(this.reservationId, (data) => {
        this.isLoading = false;
        this.vouchers = data.vouchers;
      });
    },
    downloadVoucher(voucher) {
      userApi.downloadVoucher(this.reservationId, voucher, voucher.label);
    },
    showVoucher(voucher) {
      const isHotelVoucher = voucher.voucher_type === 'accommodation_hotel';
      const isActivityVoucher = voucher.voucher_type === 'activity_full_page';
      const isShipVoucher = voucher.voucher_type === 'accommodation_ship';
      const isPickUpVoucher = voucher.voucher_type === 'pick_up_full_page';
      let show = isHotelVoucher || isActivityVoucher || isShipVoucher || isPickUpVoucher;
      if (isPickUpVoucher) {
        if (this.entity.name === 'amicitia') {
          if (this.travelPackageType === 'fly_trip') {
            show = false;
          }
        } else if (this.entity.name === 'amigo') {
          if (this.travelPackageType !== 'touring_car_trip') {
            show = false;
          }
        } else if (this.entity.name === 'ncrv-reizen') {
          if (this.travelPackageType !== 'touring_car_trip') {
            show = false;
          }
        }
      }

      if (this.entity.name === 'amigo') {
        if (isHotelVoucher || isShipVoucher) {
          show = false;
        }
      }
      return show;
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// voucher-list.vue?356c5dfe